<template>
  <v-dialog 
    v-model="dialog" 
    fullscreen 
    hide-overlay 
    transition="fade-transition"
  >
    <v-overlay opacity="0.95" class="fullScreenMenu" @click.native="dialog = false">
      <v-btn icon fixed right top @click="dialog = false">
        <v-icon>fa-times</v-icon>
      </v-btn>

      <v-row class="flex-column text-center">
        <router-link to="/">首頁</router-link>
        <router-link v-if="!isLogin" class="d-flex align-center" to="/login">
          <v-icon small class="mr-2">fa-user</v-icon>
          登入
        </router-link>
        <router-link v-else to="/profile">
          個人主頁
        </router-link>
<!--           <a class="base d-flex align-center" @click="$root.$emit('peachList')">
            <div class="peach"></div>
            <span class="pink--text">{{ user.peach }}</span>
          </a> -->
        <router-link to="/shoppingcart">購物車</router-link>
        <a @click="$root.$emit('peachList')">購買桃子</a>
      </v-row>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['isLogin']),
  },
}  
</script>

<style lang="scss" scoped>
.fullScreenMenu {
  a {
    color: white !important;
    padding: 10px;
    &:hover {
      color: #E91E63 !important;
      i {
        color: #E91E63;
      }
    }
  }
}
</style>